import { jsx as _jsx } from "react/jsx-runtime";
// import * as Languages from 'pricing-pages-lib/constants/Languages';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { // getI18nLanguage,
I18nLookup } from 'pricing-pages-lib/utils/languageUtils';

// @TODO
// Translation request for es.pricing-pages.tooltips.labels.PROFESSIONAL to add space
const TranslatedFeature = ({
  feature,
  productLine,
  productLevel,
  attribute,
  needsProductLineIndexing,
  needsProductLevelIndexing
}) => {
  /** TODO: remove to use feature store
   * const lang = getI18nLanguage();
   * if (lang === Languages.EN && englishTranslation) {
   *  return <>{englishTranslation}</>;
   *}
   */
  if (!needsProductLineIndexing) {
    const lookupVal = `pricing-pages.features.${feature.shortName}.${attribute}`;

    if (I18nLookup(lookupVal)) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: lookupVal
      });
    }
  }

  if (needsProductLineIndexing && !needsProductLevelIndexing) {
    const hasHubSpecificLanguage = I18nLookup(`pricing-pages.features.${feature.shortName}.${attribute}.${productLine}`);
    const keyToUse = hasHubSpecificLanguage ? productLine : 'default';
    const lookupVal = `pricing-pages.features.${feature.shortName}.${attribute}.${keyToUse}`;

    if (I18nLookup(lookupVal)) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: lookupVal
      });
    }
  }

  if (needsProductLineIndexing && needsProductLevelIndexing) {
    const hasHubSpecificLanguage = I18nLookup(`pricing-pages.features.${feature.shortName}.${attribute}.${productLine}`);
    const keyToUse = hasHubSpecificLanguage ? productLine : 'default';
    const lookupVal = `pricing-pages.features.${feature.shortName}.${attribute}.${keyToUse}.${productLevel}`;

    if (I18nLookup(lookupVal)) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: lookupVal
      });
    }
  }

  return null;
};

export default TranslatedFeature;